var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-sign-page"},[(!_vm.done)?_c('div',{staticClass:"sign-body"},[_c('MobileSignaturePad',{attrs:{"uuid":_vm.uuid,"token":_vm.token},on:{"signed":_vm.onSigned}})],1):_c('div',{staticClass:"sign-receipt"},[_c('i',{staticClass:"el-icon-success"}),_c('p',[_vm._v(_vm._s(_vm.$t("signature.done")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }